import { BaseEntity } from "yt-ng-framework"

export class UserProvajderView extends BaseEntity{
    constructor(){
        super();
    }

    ID: number = null;
    UserId: number = null;
    FirmaID: number = null;
    SefProvajderId: number = null;
    Username: string = null;
    Password: string = null;
    ApyKey: string = null;
    DocloopSoftwareId: string = null;
    Pib: string = null;
    Url: string = null;
    GenericName: string = null;
    Korisnik: string = null;
    Provajder: string = null;
    Firma: string = null;
    IsActive: boolean = null;
    MiniBizUsername: string = null;
    EOtpremnicaApiKey: string = null;
    EOtpremnicaUrl: string = null;
    EOtprProvajder : string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.UserId = input.UserId;
        this.FirmaID = input.FirmaID;
        this.SefProvajderId = input.SefProvajderId;
        this.Username = input.Username;
        this.Password = input.Password;
        this.ApyKey = input.ApyKey;
        this.Pib = input.Pib;
        this.Url = input.Url;
        this.GenericName = input.GenericName;
        this.DocloopSoftwareId = input.DocloopSoftwareId;
        this.IsActive = input.IsActive;
        this.Korisnik = input.Korisnik;
        this.Provajder = input.Provajder;
        this.Firma = input.Firma
        this.MiniBizUsername = input.MiniBizUsername;
        this.EOtpremnicaApiKey = input.EOtpremnicaApiKey;
        this.EOtpremnicaUrl = input.EOtpremnicaUrl;
        this.EOtprProvajder = input.EOtprProvajder;
        return this;
    }

    Serialize(input: UserProvajderView): {} {
        return input;
    }
}